// externals
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

// hooks
import { useDaysToFirstPaymentField } from './hooks/useDaysToFirstPaymentField';

const DaysToFirstPaymentField = () => {
    const { label, inputProps } = useDaysToFirstPaymentField();

    return (
        <>
            <label
                style={{ height: '17px' }}
                className="first-payment-date base-deal-activity-control-custom-label"
                data-testid="first-payment-date"
                htmlFor={inputProps.id}
            >
                {label}
            </label>
            <NumericInput {...inputProps} />
        </>
    );
};

export default DaysToFirstPaymentField;
